import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: column !important;
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  .cntAll {
    width: 100%;
    .cnt {
      width: 100%;
      padding-top: 40px;
      padding-left: 100px;

      .cntSolicitation {
        width: 100%;
        padding-bottom: 46px;
        max-width: 310px;
      }
      .cntSugestion {
        padding-bottom: 46px;
        width: 100%;
        max-width: 310px;
      }

      .cntFriends {
        width: 100%;
        max-width: calc(100% - 146px);
        padding-bottom: 46px;
      }
    }
    .title {
      display: flex;
      text-align: left;
      font: normal normal normal 20px/26px Futura PT;
      letter-spacing: 0px;
      color: ${({ theme }) => theme.colors.secondary};
      opacity: 1;
      padding-bottom: 10px;
      margin-left: -5%;
    }
    .box {
      width: 307px;
      height: 87px;
      background: ${({ theme }) => theme.colors.background} 0% 0% no-repeat padding-box;
      border-radius: 16px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      .picture {
        width: 100%;
        max-width: 63px;
        height: 63px;
        border-radius: 50%;
        background: ${({ theme }) => theme.colors.secondary} 0% 0% no-repeat padding-box;
        margin-left: -8%;
        img {
          border-radius: 50%;
          width: 100%;
        }
      }
      .boxInfo {
        width: 100%;
        padding-left: 20px;
        .name {
          text-align: left;
          font: normal normal normal 16px/21px Futura PT;
          letter-spacing: 0px;
          color: ${({ theme }) => theme.colors.secondary};
          opacity: 1;
        }
        .boxButtons {
          display: flex;
          justify-content: space-between;
          max-width: 221px;
          padding-top: 15px;
        }
      }
    }
  }
`;
